const SIMPLIFIED_TO_TRADITIONAL = {
  与: '與',
  为: '為',
  个: '個',
  这: '這',
  里: '裡',
  书: '書',
  国: '國',
  万: '萬',
  无: '無',
  义: '義',
  两: '兩',
  头: '頭',
  钳: '鉗',
  术: '術',
  灵: '靈',
  签: '籤',
  诗: '詩',
  观: '觀',
  黄: '黃',
  龙: '龍',
  马: '馬',
  纳: '納',
  订: '訂',
  鸡: '雞',
  猪: '豬',
  鹤: '鶴',
  鸾: '鸞',
  财: '財',
  贫: '貧',
  贵: '貴',
  败: '敗',
  贤: '賢',
  费: '費',
  赚: '賺',
  资: '資',
  产: '產',
  业: '業',
  务: '務',
  动: '動',
  势: '勢',
  劳: '勞',
  运: '運',
  岁: '歲',
  时: '時',
  阳: '陽',
  阴: '陰',
  历: '曆',
  农: '農',
  冲: '沖',
  关: '關',
  系: '係',
  复: '覆',
  后: '後',
  见: '見',
  问: '問',
  说: '說',
  请: '請',
  语: '語',
  读: '讀',
  诉: '訴',
  讲: '講',
  证: '證',
  详: '詳',
  计: '計',
  算: '算',
  应: '應',
  临: '臨',
  属: '屬',
  体: '體',
  总: '總',
  家: '家',
  庭: '庭',
  婚: '婚',
  姻: '姻',
  健: '健',
  康: '康',
  医: '醫',
  伤: '傷',
  忧: '憂',
  恶: '惡',
  牵: '牽',
  进: '進',
  过: '過',
  远: '遠',
  连: '連',
  迟: '遲',
  选: '選',
  开: '開',
  发: '發',
  变: '變',
  兴: '興',
  达: '達',
  门: '門',
  间: '間',
  闲: '閒',
  难: '難',
  风: '風',
  飞: '飛',
  云: '雲',
  乡: '鄉',
  声: '聲',
  场: '場',
  坛: '壇',
  图: '圖',
  盘: '盤',
  条: '條',
  来: '來',
  梦: '夢',
  极: '極',
  标: '標',
  横: '橫',
  补: '補',
  炼: '煉',
  点: '點',
  爱: '愛',
  电: '電',
  现: '現',
  禄: '祿',
  称: '稱',
  稳: '穩',
  穷: '窮',
  简: '簡',
  经: '經',
  终: '終',
  绪: '緒',
  缘: '緣',
  续: '續',
  综: '綜',
  罗: '羅',
  聪: '聰',
  职: '職',
  节: '節',
  药: '藥',
  虚: '虛',
  虑: '慮',
  触: '觸',
  识: '識',
  谋: '謀',
  谷: '谷',
  车: '車',
  转: '轉',
  轻: '輕',
  输: '輸',
  钟: '鐘',
  铁: '鐵',
  长: '長',
  须: '須',
  顾: '顧',
  题: '題',
  颜: '顏',
  东: '東',
  丝: '絲',
  丰: '豐',
  丽: '麗',
  举: '舉',
  乌: '烏',
  乐: '樂',
  习: '習',
  乱: '亂',
  争: '爭',
  于: '於',
  亏: '虧',
  亲: '親',
  从: '從',
  仓: '倉',
  仪: '儀',
  价: '價',
  众: '衆',
  优: '優',
  伙: '夥',
  传: '傳',
  余: '餘',
  俭: '儉',
  倾: '傾',
  偿: '償',
  储: '儲',
  儿: '兒',
  兰: '蘭',
  兹: '茲',
  养: '養',
  凄: '悽',
  几: '幾',
  凶: '兇',
  击: '擊',
  则: '則',
  刚: '剛',
  创: '創',
  别: '別',
  劝: '勸',
  华: '華',
  单: '單',
  却: '卻',
  厦: '廈',
  双: '雙',
  叶: '葉',
  叹: '嘆',
  吃: '喫',
  咸: '鹹',
  园: '園',
  圆: '圓',
  圣: '聖',
  坏: '壞',
  壮: '壯',
  处: '處',
  夸: '誇',
  奋: '奮',
  妇: '婦',
  孙: '孫',
  学: '學',
  宁: '寧',
  实: '實',
  宫: '宮',
  宽: '寬',
  对: '對',
  寻: '尋',
  寿: '壽',
  将: '將',
  尘: '塵',
  尝: '嘗',
  尽: '盡',
  岖: '嶇',
  带: '帶',
  帮: '幫',
  并: '並',
  广: '廣',
  庆: '慶',
  废: '廢',
  异: '異',
  张: '張',
  弥: '彌',
  强: '強',
  归: '歸',
  当: '當',
  怀: '懷',
  恼: '惱',
  惊: '驚',
  戏: '戲',
  户: '戶',
  扬: '揚',
  报: '報',
  担: '擔',
  挂: '掛',
  挣: '掙',
  捞: '撈',
  损: '損',
  换: '換',
  数: '數',
  斗: '鬥',
  断: '斷',
  旧: '舊',
  显: '顯',
  暂: '暫',
  机: '機',
  杂: '雜',
  权: '權',
  杨: '楊',
  枣: '棗',
  枪: '槍',
  树: '樹',
  楼: '樓',
  欢: '歡',
  残: '殘',
  气: '氣',
  没: '沒',
  泞: '濘',
  泽: '澤',
  济: '濟',
  渐: '漸',
  游: '遊',
  滚: '滾',
  满: '滿',
  滩: '灘',
  灾: '災',
  烦: '煩',
  犹: '猶',
  独: '獨',
  环: '環',
  画: '畫',
  癫: '癲',
  盖: '蓋',
  碍: '礙',
  礼: '禮',
  祸: '禍',
  离: '離',
  种: '種',
  积: '積',
  笼: '籠',
  筹: '籌',
  红: '紅',
  纯: '純',
  纵: '縱',
  绅: '紳',
  细: '細',
  结: '結',
  统: '統',
  绣: '繡',
  维: '維',
  绵: '綿',
  网: '網',
  群: '羣',
  胜: '勝',
  胧: '朧',
  脱: '脫',
  腊: '臘',
  艰: '艱',
  艳: '豔',
  艺: '藝',
  荣: '榮',
  获: '獲',
  营: '營',
  蓝: '藍',
  虽: '雖',
  觅: '覓',
  觉: '覺',
  誉: '譽',
  许: '許',
  论: '論',
  谁: '誰',
  谒: '謁',
  谓: '謂',
  谨: '謹',
  负: '負',
  质: '質',
  贪: '貪',
  赋: '賦',
  赐: '賜',
  赔: '賠',
  赞: '贊',
  踪: '蹤',
  轩: '軒',
  载: '載',
  辉: '輝',
  边: '邊',
  还: '還',
  适: '適',
  遗: '遺',
  遥: '遙',
  钦: '欽',
  钱: '錢',
  银: '銀',
  锁: '鎖',
  错: '錯',
  锦: '錦',
  镜: '鏡',
  闯: '闖',
  闺: '閨',
  闻: '聞',
  阁: '閣',
  险: '險',
  随: '隨',
  静: '靜',
  项: '項',
  顺: '順',
  领: '領',
  频: '頻',
  飘: '飄',
  饥: '飢',
  饭: '飯',
  饼: '餅',
  驳: '駁',
  鱼: '魚',
  鲜: '鮮',
  鸟: '鳥',
  鸣: '鳴',
  鸯: '鴦',
  鸳: '鴛',
  齐: '齊',
};

const TRADITIONAL_TO_SIMPLIFIED = Object.entries(SIMPLIFIED_TO_TRADITIONAL)
  .reduce((acc, [simplified, traditional]) => {
    if (!acc[traditional]) acc[traditional] = simplified;
    return acc;
  }, {});

const ENGLISH_TERM_REPLACEMENTS = {
  '欽定協紀辨方書': 'Imperially Commissioned Xieji Bianfang Shu',
  '移徙入宅': 'Moving / Home Entry',
  '訂盟簽約': 'Engagement / Contract Signing',
  '祭祀祈福': 'Worship / Blessing Prayer',
  '自訂事項': 'Custom Event',
  '嫁娶': 'Marriage',
  '納采': 'Betrothal Gifts',
  '訂盟': 'Engagement Pact',
  '移徙': 'Moving',
  '入宅': 'Home Entry',
  '安床': 'Bed Placement',
  '安香': 'Incense Altar Setup',
  '開市': 'Market Opening',
  '開業': 'Business Opening',
  '交易': 'Trading',
  '立券': 'Signing Deeds',
  '納財': 'Receiving Wealth',
  '出行': 'Travel',
  '赴任': 'Taking Office',
  '祭祀': 'Worship',
  '祈福': 'Blessing Prayer',
  '齋醮': 'Taoist Ritual',
  '開光': 'Consecration',
  '作灶': 'Stove Setup',
  '冠笄': 'Coming-of-age Rite',
  '裁衣': 'Tailoring',
  '會親友': 'Meeting Relatives and Friends',
  '納畜': 'Livestock Keeping',
  '牧養': 'Herding',
  '安機械': 'Installing Machinery',
  '安葬': 'Burial',
  '破土': 'Breaking Ground for Burial',
  '動土': 'Earth Breaking',
  '修造': 'Renovation',
  '黃道': 'Yellow Path',
  '黑道': 'Black Path',
  '吉神見': 'Auspicious stars present:',
  '凶煞見': 'Inauspicious stars present:',
  '日課宜': 'Almanac recommends',
  '日課忌': 'Almanac avoids',
  '與所選事項相合': 'matching the selected event',
  '不宜作首選': 'not a first-choice day',
  '建除值日為': 'Jianchu day officer:',
  '合此事': 'suits this event',
  '此事宜慎': 'use caution for this event',
  '天神': 'Heavenly deity',
  '日沖': 'Day clash with ',
  '大吉可用': 'Excellent and usable',
  '吉日可取': 'Good day',
  '平日可用': 'Ordinary but usable',
  '可用但須避沖': 'Usable, but avoid clashes',
  '不宜首選': 'Not a first choice',
  '宜另擇日': 'Choose another day',
  '天德': 'Heavenly Virtue',
  '月德': 'Monthly Virtue',
  '天喜': 'Heavenly Joy',
  '三合': 'Three Harmony',
  '六合': 'Six Harmony',
  '母倉': 'Mother Storehouse',
  '金匱': 'Golden Cabinet',
  '青龍': 'Azure Dragon',
  '明堂': 'Bright Hall',
  '天恩': 'Heavenly Grace',
  '天倉': 'Heavenly Storehouse',
  '月厭': 'Monthly Aversion',
  '孤辰': 'Solitary Star',
  '寡宿': 'Widow Star',
  '往亡': 'Departure Void',
  '大煞': 'Great Sha',
  '四擊': 'Four Strikes',
  '血忌': 'Blood Taboo',
  '朱雀': 'Vermilion Bird',
  '白虎': 'White Tiger',
  '月破': 'Monthly Break',
  '劫煞': 'Robbery Sha',
  '災煞': 'Disaster Sha',
  '土府': 'Earth Storehouse',
  '地火': 'Earth Fire',
  '大耗': 'Great Loss',
  '五虛': 'Five Emptiness',
  '月恩': 'Monthly Grace',
  '月空': 'Monthly Void',
  '月煞': 'Monthly Sha',
  '月虛': 'Monthly Emptiness',
  '月刑': 'Monthly Punishment',
  '月害': 'Monthly Harm',
  '天醫': 'Heavenly Doctor',
  '天刑': 'Heavenly Punishment',
  '天牢': 'Heavenly Prison',
  '天后': 'Heavenly Queen',
  '天吏': 'Heavenly Officer',
  '天巫': 'Heavenly Shaman',
  '天賊': 'Heavenly Thief',
  '玄武': 'Black Tortoise',
  '玉堂': 'Jade Hall',
  '玉宇': 'Jade Mansion',
  '寶光': 'Precious Light',
  '益後': 'Benefit Descendants',
  '續世': 'Continuing Generations',
  '聖心': 'Sacred Heart',
  '五富': 'Five Wealth',
  '五合': 'Five Harmony',
  '五離': 'Five Separation',
  '四相': 'Four Ministers',
  '六儀': 'Six Etiquettes',
  '八風': 'Eight Winds',
  '元武': 'Black Warrior',
  '復日': 'Repeating Day',
  '重日': 'Double Day',
  '王日': 'Royal Day',
  '官日': 'Official Day',
  '守日': 'Guarding Day',
  '相日': 'Minister Day',
  '要安': 'Need Peace',
  '生氣': 'Life Qi',
  '不將': 'No General',
  '血支': 'Blood Branch',
  '厭對': 'Aversion Pair',
  '招搖': 'Restless Star',
  '河魁': 'River Kui',
  '遊禍': 'Wandering Trouble',
  '致死': 'Deathly Qi',
  '大會': 'Great Assembly',
  '驛馬': 'Traveling Horse',
  '鳴吠': 'Barking Star',
  '觸水龍': 'Touching Water Dragon',
  '金堂': 'Golden Hall',
  '天馬': 'Heavenly Horse',
  '時陽': 'Timely Yang',
  '除神': 'Removal Spirit',
  '相關人士': 'Related Person',
  '新郎': 'Groom',
  '新娘': 'Bride',
  '父親': 'Father',
  '母親': 'Mother',
  '木': 'Wood',
  '火': 'Fire',
  '土': 'Earth',
  '金': 'Metal',
  '水': 'Water',
  '陽': 'Yang',
  '陰': 'Yin',
  '屬': ' is ',
  '甲': 'Jia',
  '乙': 'Yi',
  '丙': 'Bing',
  '丁': 'Ding',
  '戊': 'Wu',
  '己': 'Ji',
  '庚': 'Geng',
  '辛': 'Xin',
  '壬': 'Ren',
  '癸': 'Gui',
  '子': 'Zi (Rat)',
  '丑': 'Chou (Ox)',
  '醜': 'Chou (Ox)',
  '寅': 'Yin (Tiger)',
  '卯': 'Mao (Rabbit)',
  '辰': 'Chen (Dragon)',
  '巳': 'Si (Snake)',
  '午': 'Wu (Horse)',
  '未': 'Wei (Goat)',
  '申': 'Shen (Monkey)',
  '酉': 'You (Rooster)',
  '戌': 'Xu (Dog)',
  '亥': 'Hai (Pig)',
  '鼠': 'Rat',
  '牛': 'Ox',
  '虎': 'Tiger',
  '兔': 'Rabbit',
  '龍': 'Dragon',
  '蛇': 'Snake',
  '馬': 'Horse',
  '羊': 'Goat',
  '猴': 'Monkey',
  '雞': 'Rooster',
  '狗': 'Dog',
  '豬': 'Pig',
  '建': 'Establish',
  '除': 'Remove',
  '滿': 'Full',
  '平': 'Balance',
  '定': 'Settle',
  '執': 'Hold',
  '破': 'Break',
  '危': 'Danger',
  '成': 'Success',
  '收': 'Receive',
  '開': 'Open',
  '閉': 'Close',
  '吉': 'Auspicious',
  '凶': 'Inauspicious',
  '兇': 'Inauspicious',
  '一': 'Monday',
  '二': 'Tuesday',
  '三': 'Wednesday',
  '四': 'Thursday',
  '五': 'Friday',
  '六': 'Saturday',
  '日': 'Sunday',
  '東': 'East',
  '西': 'West',
  '南': 'South',
  '北': 'North',
  '婁': 'Lou Mansion',
  '胃': 'Wei Mansion',
  '昴': 'Mao Mansion',
  '畢': 'Bi Mansion',
  '觜': 'Zi Mansion',
  '參': 'Shen Mansion',
  '井': 'Jing Mansion',
  '鬼': 'Gui Mansion',
  '柳': 'Liu Mansion',
  '星': 'Xing Mansion',
  '張': 'Zhang Mansion',
  '翼': 'Yi Mansion',
  '軫': 'Zhen Mansion',
  '角': 'Jiao Mansion',
  '亢': 'Kang Mansion',
  '氐': 'Di Mansion',
  '房': 'Fang Mansion',
  '心': 'Xin Mansion',
  '尾': 'Wei Mansion',
  '箕': 'Ji Mansion',
  '斗': 'Dou Mansion',
  '女': 'Nu Mansion',
  '虛': 'Xu Mansion',
  '室': 'Shi Mansion',
  '壁': 'Bi Mansion',
  '奎': 'Kui Mansion',
};

const ENGLISH_PHRASE_ANCHORS = [
  '日課',
  '建除值日',
  '吉神見',
  '凶煞見',
  '天神',
  '日沖',
  '所選事項',
  '不宜作首選',
];

const ENGLISH_PUNCTUATION_REPLACEMENTS = {
  '、': ', ',
  '，': ', ',
  '。': '.',
  '；': '; ',
  '：': ': ',
  '（': ' (',
  '）': ')',
  '「': '"',
  '」': '"',
  '　': ' ',
};

const replaceCharacters = (text, map) => text.replace(/[\u4e00-\u9fff]/g, (char) => map[char] || char);

const SAFE_SINGLE_ENGLISH_TERMS = new Set([
  '甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸',
  '子', '丑', '醜', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥',
  '鼠', '牛', '虎', '兔', '龍', '蛇', '馬', '羊', '猴', '雞', '狗', '豬',
  '吉', '凶', '兇', '屬',
]);

const replaceEnglishTerms = (text) => {
  const traditional = replaceCharacters(text, SIMPLIFIED_TO_TRADITIONAL);
  if (traditional.startsWith('以選擇用事為本')) {
    return 'Select dates by matching the event with the day\'s suitable and unsuitable activities, auspicious and inauspicious stars, Jianchu day officer, Yellow/Black Path status, and zodiac clashes with the related people.';
  }
  const chongMatch = traditional.match(/^\(([甲乙丙丁戊己庚辛壬癸子丑寅卯辰巳午未申酉戌亥]{2})\)([鼠牛虎兔龍蛇馬羊猴雞狗豬])$/);
  if (chongMatch) {
    return `${chongMatch[1].split('').map((char) => ENGLISH_TERM_REPLACEMENTS[char] || char).join('')} ${ENGLISH_TERM_REPLACEMENTS[chongMatch[2]]}`;
  }
  const hasKnownListTerms = traditional.length <= 80 && Object.keys(ENGLISH_TERM_REPLACEMENTS)
    .some((term) => term.length > 1 && traditional.includes(term));
  const hasPhraseAnchor = ENGLISH_PHRASE_ANCHORS.some((anchor) => traditional.includes(anchor));
  const looksLikeGanzi = /^[甲乙丙丁戊己庚辛壬癸子丑寅卯辰巳午未申酉戌亥]{1,4}$/.test(traditional);
  const looksLikeZodiacList = /^[鼠牛虎兔龍蛇馬羊猴雞狗豬、，,\s]+$/.test(traditional);
  const shouldTranslateSingle = hasPhraseAnchor || looksLikeGanzi || looksLikeZodiacList;
  const shouldTranslate = ENGLISH_PHRASE_ANCHORS.some((anchor) => traditional.includes(anchor))
    || ENGLISH_TERM_REPLACEMENTS[traditional]
    || hasKnownListTerms
    || looksLikeGanzi
    || looksLikeZodiacList;
  if (!shouldTranslate) return traditional;
  let result = traditional;
  Object.keys(ENGLISH_TERM_REPLACEMENTS)
    .sort((a, b) => b.length - a.length)
    .forEach((source) => {
      if (source.length > 1 || shouldTranslateSingle || SAFE_SINGLE_ENGLISH_TERMS.has(source)) {
        result = result.split(source).join(ENGLISH_TERM_REPLACEMENTS[source]);
      }
    });
  Object.entries(ENGLISH_PUNCTUATION_REPLACEMENTS).forEach(([source, target]) => {
    result = result.split(source).join(target);
  });
  return result.replace(/\s+/g, ' ').trim();
};

export const localizeChineseText = (value, lang = 'zh-TW') => {
  if (value === null || value === undefined) return '';
  const text = (() => {
    if (Array.isArray(value)) {
      return value
        .map((item) => localizeChineseText(item, lang))
        .filter(Boolean)
        .join('、');
    }
    if (typeof value === 'object') {
      const preferredKeys = [
        lang,
        'text',
        'summary',
        'plain',
        'verse',
        'annotation',
        'title',
        'name',
        'description',
        'overall',
      ];
      const pieces = [];
      preferredKeys.forEach((key) => {
        const nested = value[key];
        if (nested !== null && nested !== undefined && typeof nested !== 'object') {
          const rendered = String(nested).trim();
          if (rendered && !pieces.includes(rendered)) pieces.push(rendered);
        }
      });
      if (!pieces.length) {
        Object.values(value).forEach((nested) => {
          if (nested !== null && nested !== undefined && typeof nested !== 'object') {
            const rendered = String(nested).trim();
            if (rendered && !pieces.includes(rendered)) pieces.push(rendered);
          }
        });
      }
      return pieces.join(' ');
    }
    return String(value);
  })();
  if (lang === 'zh-TW') return replaceCharacters(text, SIMPLIFIED_TO_TRADITIONAL);
  if (lang === 'zh-CN') return replaceCharacters(text, TRADITIONAL_TO_SIMPLIFIED);
  if (lang === 'en') return replaceEnglishTerms(text);
  return text;
};

export default localizeChineseText;
